import React, { useEffect, useState } from "react";
import "./invoice.scss";
import { errorSnackBar } from "./../../../actions/common.action";
import { INVOICES, RECEIVABLES } from "../../../constants/route-paths";
import {
  getProjectList as getProjectListAPI,
} from "./../../../actions/project-management.action";
import { getCustomerList } from "./../../../actions/customer-management.action";
import {
  getProgressClaimList,
  saveInvoice,
} from "./../../../actions/invoice.action";
import _ from "lodash";
import Button from 'react-bootstrap/Button';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import DatePickerInput from "../../../components/inputs/date-picker";
import SelectInput from "../../../components/inputs/select";
import ViewInvoiceDiscription from "src/components/view-invoice-description/view";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";

function CreateInvoice(props) {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [fields, setFields] = useState({
    customer: {
      name: "customer",
      value: "",
      items: [],
      type: "select",
    },
    workType: {
      name: "workType",
      value: "project",
      items: [{ key: "Project", value: "project" }],
      type: "select",
    },
    project: {
      name: "project",
      value: "",
      items: [],
      type: "select",
    },
    progressClaim: {
      name: "progressClaim",
      value: "",
      items: [],
      type: "select",
    },
    invoiceDate: {
      name: "invoiceDate",
      value: new Date(),
      type: "datepicker",
    },
    dueDate: {
      name: "dueDate",
      value: "",
      type: "datepicker",
    },
  })
  const [state, setState] = useState({
    projectsList: [],
    customersList: [],
    invoiceData: {},
    projectId: "",
    workType: "",
    projectQuoteType: ""
  })

  useEffect(() => {
    getCustomersList();
  }, [])

  const getCustomersList = () => {
    dispatch(getCustomerList('business_name,first_name,name')).then((customers) => {
      const customersList = [];
      customers.forEach((customer) =>
        customersList.push({ key: customer.businessName, value: customer.id })
      );
      setFields(prev => ({
        ...prev,
        customer: { ...prev.customer, items: customersList }
      }));
    });
  };

  const getProjectList = async (value = '') => {
    const customerId = value || fields.customer.value;
    let list = await dispatch(getProjectListAPI(null, null, customerId)).catch(e => console.error(e));

    let projects = [];
    list &&
      list.forEach(({ name, id }) => projects.push({ key: name, value: id }));

    projects = _.orderBy(projects, [({ key }) => key.toLowerCase()], ["asc"]);
    setFields(prev => ({
      ...prev,
      project: { ...prev.project, items: projects }
    }));
  };

  const getProgressClaims = async (projectId) => {
    let query = `?projectId=${projectId}`;
    let claims = await dispatch(getProgressClaimList(query)).catch(e => console.error(e));
    const progressClaims = [];
    claims.forEach((claim) =>
      progressClaims.push({ key: claim.id, value: claim.u_id, ...claim })
    );
    setFields(prev => ({
      ...prev,
      progressClaim: { ...prev.progressClaim, items: progressClaims }
    }));
  };

  const changeCustomer = (value) => {
    const invoiceData = {};
    const workType = "";
    setFields(prev => ({
      ...prev,
      customer: { ...prev.customer, value: value },
      project: { ...prev.project, value: '' },
      progressClaim: { ...prev.progressClaim, value: '' },
      dueDate: { ...prev.dueDate, value: '' },
      invoiceDate: { ...prev.invoiceDate, value: '' }
    }));
    setState(prev => ({
      ...prev,
      workType, invoiceData, projectId: ""
    }));
    getProjectList(value)
  };

  const changeProject = (value) => {
    const invoiceData = {};
    setFields(prev => ({
      ...prev,
      project: { ...prev.project, value: value },
      progressClaim: { ...prev.progressClaim, value: '' },
      dueDate: { ...prev.dueDate, value: '' },
      invoiceDate: { ...prev.invoiceDate, value: '' },
    }));
    setState(prev => ({
      ...prev,
      projectId: value, invoiceData
    }));
    getProgressClaims(value);
  };

  const changeClaim = (value) => {
    const claims = fields.progressClaim.items;

    const invoiceData = claims.find((claim) => claim.value == value);
    setFields(prev => ({
      ...prev,
      progressClaim: { ...prev.progressClaim, value: value },
    }));
    setState(prev => ({
      ...prev,
      invoiceData: invoiceData,
      projectQuoteType: invoiceData.project.quote_type,
    }));
  };

  const changeDate = (value, type) => {
    setFields(prev => ({
      ...prev,
      ...(type == "invoice" ? { invoiceDate: { ...prev.invoiceDate, value: value } } : {}),
      ...(type != "invoice" ? { dueDate: { ...prev.dueDate, value: value } } : {}),
    }));
  };

  const cancelHandler = () => {
    navigate(`/${RECEIVABLES}/${INVOICES}`);
  };

  const generateInvoice = async () => {
    if (fields.progressClaim.value === "") {
      dispatch(errorSnackBar("Please Select Progress Claim"));
      return;
    }
    if (fields.invoiceDate.value === "") {
      dispatch(errorSnackBar("Please Select Invoice Date"));
      return;
    }
    if (fields.dueDate.value === "") {
      dispatch(errorSnackBar("Please Select Due Date"));
      return;
    }
    const data = {
      progressClaimId: fields.progressClaim.value,
      dueDate: fields.dueDate.value,
      invoiceDate: fields.invoiceDate.value,
    };
    await dispatch(saveInvoice(data)).catch(e => console.error(e));
    cancelHandler();
  };

  return (
    <div className="purchase-order-block">
      <h2 className="content-heading text-uppercase">Create Invoice</h2>
      <div className="col-12 breadcrumb-block p-0">
        <Breadcrumb>
          <Breadcrumb.Item onClick={cancelHandler}>INVOICE</Breadcrumb.Item>
          <Breadcrumb.Item active>Create Invoice</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <div className="row">
        <div className="col-lg-4 col-md-6 mt-3">
          <SelectInput
            {...fields.customer}
            label={'Customer'}
            onChange={(e) => changeCustomer(e.target.value)}
          />
        </div>

        <div className="col-lg-4 col-md-6 mt-3">
          <SelectInput
            {...fields.project}
            label={'Project'}
            onChange={(e) => changeProject(e.target.value)}
          />
        </div>
        <div className="col-lg-4 col-md-6 mt-3">
          <SelectInput
            {...fields.progressClaim}
            label={'Progress Claim'}
            onChange={(e) => changeClaim(e.target.value)}
          />
        </div>
        <div className="col-lg-4 col-md-4 mt-3">
          <DatePickerInput
            {...fields.invoiceDate}
            label={'Invoice Date'}
            onChange={(e) => changeDate(e, "invoice")}
          />
        </div>

        <div className="col-lg-4 col-md-4 mt-3">
          <DatePickerInput
            {...fields.dueDate}
            label={'End Date'}
            onChange={(e) => changeDate(e, "due")}
          />
        </div>
      </div>
      <ViewInvoiceDiscription
        invoiceData={state.invoiceData}
        showClaimHistory={false}
        invoiceAndProgressClaim={_.isEmpty(state.invoiceData) ? {} : fields.progressClaim.items}
      />

      <div className="col-12 d-flex mt-3">
        <Button onClick={generateInvoice} className="ms-auto me-3 secondarybtn">SUBMIT</Button>
        <Button onClick={cancelHandler} className="secondarybtn cancelbtn me-auto">CANCEL</Button>
      </div>
    </div>
  );

}

export default CreateInvoice;
